// src/api/notificationsApi.js
import api from "./axios";

/**
 * Fetch latest 30 notifications + total unread count for the current user.
 * GET /api/notifications/
 */
export const getNotifications = () => api.get("/api/notifications/");

/**
 * Mark a single notification as read.
 * POST /api/notifications/<id>/read/
 */
export const markNotificationRead = (id) =>
  api.post(`/api/notifications/${id}/read/`);

/**
 * Mark every unread notification as read.
 * POST /api/notifications/read-all/
 */
export const markAllNotificationsRead = () =>
  api.post("/api/notifications/read-all/");
